<template>
    <div id="page">
        <data-table class="pages" v-blur="blur"
                    :clientPagination="false"
                    :cols="columns"
                    :dateColumns="dateColumns"
                    :screenshotColumns="screenshotColumns"
                    :url="url"
                    :orderBy="orderBy"
                    :title="'Deceptive Phishing Hosting'"
                    :dataPath="dataPath"
                    :requestParams="requestParams"
                    :filterableGlobal="isFilterableGlobal"
                    :fullPageName="pageName"
                    :partnerId="partnerId"
                    @onDetailsClick="onDetailsClick"
                    @loading="onLoading"
                    @loaded="onLoaded"
                    :isNotification="isSaveChanges"
                    @saveResolutionChanges="saveResolutionChanges"
                    :isSummaryVisible="true"
                    @toggleLoading="toggleLoading"
                    :summaryRequestParams="summaryRequestParams"
                    ref="deceptivePhishingHostingDataTable"
                    :isStixExportAvailable="isStixExportAvailable"
        ></data-table>
        <loading-modal class="loading-modal-container" v-if="loading"></loading-modal>
    </div>
</template>

<script>

    import Common from '@/utils/Common.vue'
    import Constants from '@/utils/constants'
    import DataTable from '@/components/datatable/DataTable.vue'
    import LoadingModal from '@/components/modals/LoadingModal.vue'

    export default {
        name: 'deceptive-phishing-hosting',
        components: {
            DataTable: DataTable,
            LoadingModal: LoadingModal
        },
        props: {
            incomingThreatPageType: {
                type: Number,
                required: true
            }
        },
        mixins: [Common],
        data() {
            if (this.incomingThreatPageType === Constants.ThreatPageTypes.Partner) {
                return {
                    requestParams: {'is_partner': true},
                    loading: false,
                    screenshotColumns: [{column: "screenshot", urlColumn: "url"}],
                    isSaveChanges: false
                }
            }
            else if (this.incomingThreatPageType === Constants.ThreatPageTypes.Matched) {
                return {
                    requestParams: {'is_partner': false},
                    loading: false,
                    screenshotColumns: [{column: "screenshot", urlColumn: "url"}],
                    isSaveChanges: true
                }
            }
            else {
                return {
                    requestParams: {'is_partner': false},
                    loading: false,
                    screenshotColumns: [{column: "screenshot", urlColumn: "url"}],
                    isSaveChanges: false
                }
            }
        },
        methods: {
            toggleLoading(value){
                this.loading = value;
            },
            saveResolutionChanges(tableData) {
                this.loading = true;
                let body = {
                    table_data: tableData,
                    table_name: Constants.TableProperties.DeceptivePhishingHosting.table_name,
                    id_column: Constants.TableProperties.DeceptivePhishingHosting.id_column
                };
                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + "/update_resolutions", body).then(response => {
                    this.loading = false;
                    this.$refs.deceptivePhishingHostingDataTable.refreshServerSidePage();
                }, response => {
                    this.loading = false;
                    this.$refs.deceptivePhishingHostingDataTable.refreshServerSidePage();
                    this.showErrorMessage("Couldn't save changes.");
                });
            },
            onDetailsClick(row) {
                this.saveLog(this, this.pageName, 'Verdict Link Clicked (Url: ' + row.url + ')', null, this.partner_id);
                this.$emit("onVerdictSearchHandler", row.url, this, this.pageName, false);
            },
            onLoading() {
                this.loading = true;
            },
            onLoaded() {
                this.loading = false;
            }
        },
        computed: {
            isStixExportAvailable() {
                return this.incomingThreatPageType === Constants.ThreatPageTypes.Partner
                    || this.incomingThreatPageType === Constants.ThreatPageTypes.Matched;
            },
            partnerId() {
                if (this.incomingThreatPageType === Constants.ThreatPageTypes.Partner) {
                    return this.getSelectedPartner;
                }
                else {
                    return null;
                }
            },
            pageName() {
                switch (this.incomingThreatPageType)
                {
                    case Constants.ThreatPageTypes.Global:
                        return 'Global Threats - Deceptive / Phishing Hosting';
                    case Constants.ThreatPageTypes.Industry:
                        return 'Industry Threats - Deceptive / Phishing Hosting';
                    case Constants.ThreatPageTypes.Partner:
                        return 'Partner Threats - Deceptive / Phishing Hosting';
                    case Constants.ThreatPageTypes.Matched:
                        return 'Notifications - Deceptive / Phishing Hosting';
                    default:
                        return 'Unknown Threat Group - Deceptive / Phishing Hosting';
                }
            },
            isFilterableGlobal() {
                return true;
            },
            url() {
                if (this.incomingThreatPageType === Constants.ThreatPageTypes.Global)
                    return Constants.INTELLIGENCE_BACKEND_URL + "/enterprise/phishing_hosting/getwithpagination";
                else if (this.incomingThreatPageType === Constants.ThreatPageTypes.Industry)
                    return Constants.INTELLIGENCE_BACKEND_URL + "/industry/phishing_hosting/get";
                else
                    return Constants.INTELLIGENCE_BACKEND_URL + "/enterprise/phishing_hosting/get";
            },
            orderBy() {
                return {
                    column: "ip",
                    ascending: false
                }
            },
            blur() {
                return {
                    isBlurred: this.loading,
                    opacity: 0.3,
                    filter: 'blur(4px)',
                    transition: 'all .5s linear'
                }
            },
            dataPath() {
                // if (this.isGlobal) {
                //     return 'data.records';
                // }
                // else {
                //     return 'data';
                // }
                return 'data.records';
            },
            columns() {
                if (this.incomingThreatPageType === Constants.ThreatPageTypes.Global) {
                    return [
                        {
                            column: "targeted_brand",
                            title: "Targeted Brand",
                            class: "col-15 cell-tooltip"
                        },
                        {
                            column: "url",
                            title: "URL",
                            class: "col-40 cell-tooltip",
                            detailsRequired: -1
                        },
                        {
                            column: "displayBoth",
                            title: "Domain / IP",
                            choices: ["domain", "ip"],
                            class: "col-15 col-overflow-hidden cell-tooltip"
                        },
                        {
                            column: "date",
                            title: "Detection Date",
                            class: "col-10"
                        },
                        {
                            column: "ssThumbnail",
                            title: "Screenshot",
                            class: "col-5"
                        },
                        {
                            column: "details",
                            title: "Details",
                            class: "col-5"
                        },
                        {
                            column: "report_date",
                            title: "Report Date",
                            class: "col-10"
                        }
                    ]
                } else if (this.incomingThreatPageType === Constants.ThreatPageTypes.Partner) {
                    return [
                        {
                            column: "targeted_brand",
                            title: "Targeted Brand",
                            class: "col-10 cell-tooltip"
                        },
                        {
                            column: "url",
                            title: "URL",
                            class: "col-35 cell-tooltip",
                            detailsRequired: -1
                        },
                        {
                            column: "displayBoth",
                            title: "Domain / IP",
                            choices: ["domain", "ip"],
                            class: "col-15 col-overflow-hidden cell-tooltip"
                        },
                        {
                            column: "detection_date",
                            title: "Detection Date",
                            class: "col-10"
                        },
                        {
                            column: "ssThumbnail",
                            title: "Screenshot",
                            class: "col-5"
                        },
                        {
                            column: "details",
                            title: "Details",
                            class: "col-5"
                        },
                        {
                            column: "report_date",
                            title: "Report Date",
                            class: "col-20"
                        }
                    ]
                }
                else if (this.incomingThreatPageType === Constants.ThreatPageTypes.Matched){
                    return [
                        {
                            column: "resolution_status",
                            title: "Resolution Status",
                            class: "col-10"
                        },
                        {
                            column: "targeted_brand",
                            title: "Targeted Brand",
                            class: "col-10 cell-tooltip"
                        },
                        {
                            column: "url",
                            title: "URL",
                            class: "col-25 cell-tooltip",
                            detailsRequired: -1
                        },
                        {
                            column: "displayBoth",
                            title: "Domain / IP",
                            choices: ["domain", "ip"],
                            class: "col-15 col-overflow-hidden cell-tooltip"
                        },
                        {
                            column: "detection_date",
                            title: "Detection Date",
                            class: "col-10"
                        },
                        {
                            column: "ssThumbnail",
                            title: "Screenshot",
                            class: "col-5"
                        },
                        {
                            column: "details",
                            title: "Details",
                            class: "col-5"
                        },
                        {
                            column: "report_date",
                            title: "Report Date",
                            class: "col-10"
                        },
                        {
                            column: "current_status",
                            title: "Current Status",
                            class: "col-10"
                        }
                    ]
                }
                else {
                    return [
                        {
                            column: "targeted_brand",
                            title: "Targeted Brand",
                            class: "col-15 cell-tooltip"
                        },
                        {
                            column: "url",
                            title: "URL",
                            class: "col-40 cell-tooltip",
                            detailsRequired: -1
                        },
                        {
                            column: "displayBoth",
                            title: "Domain / IP",
                            choices: ["domain", "ip"],
                            class: "col-15 col-overflow-hidden cell-tooltip"
                        },
                        {
                            column: "detection_date",
                            title: "Detection Date",
                            class: "col-10"
                        },
                        {
                            column: "ssThumbnail",
                            title: "Screenshot",
                            class: "col-5"
                        },
                        {
                            column: "details",
                            title: "Details",
                            class: "col-5"
                        },
                        {
                            column: "report_date",
                            title: "Report Date",
                            class: "col-10"
                        }

                    ]
                }
            },
            dateColumns() {
                if (this.incomingThreatPageType === Constants.ThreatPageTypes.Global) {
                    return [{column: "date", isAsc: true}, {column: "report_date", isAsc: true}];
                }
                else {
                    return [{column: "detection_date", isAsc: true}, {column: "report_date", isAsc: true}];
                }
            },
            summaryRequestParams() {
                if (this.incomingThreatPageType === Constants.ThreatPageTypes.Global)
                    return {
                        is_partner: false,
                        threat_option: "global",
                        feed_id: Constants.FeedEnum.DECEPTIVE_PHISHING_HOSTING,
                        showListedRow: false
                    };
                else if (this.incomingThreatPageType === Constants.ThreatPageTypes.Matched) {
                    return {
                        is_partner: false,
                        threat_option: "notification",
                        feed_id: Constants.FeedEnum.DECEPTIVE_PHISHING_HOSTING,
                        showListedRow: true
                    }
                } else if (this.incomingThreatPageType === Constants.ThreatPageTypes.Industry) {
                    return {
                        is_partner: false,
                        threat_option: "industry",
                        feed_id: Constants.FeedEnum.DECEPTIVE_PHISHING_HOSTING,
                        showListedRow: false
                    }
                } else if (this.incomingThreatPageType === Constants.ThreatPageTypes.Partner) {
                    return {
                        is_partner: true,
                        threat_option: "notification",
                        feed_id: Constants.FeedEnum.DECEPTIVE_PHISHING_HOSTING,
                        showListedRow: false
                    }
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>

    #page {
        background-color: black;
        width: 100%;
        height: 94%;
        padding: 1.5% 1.5% 1% 1.5%;
    }

    .loading-modal-container {
        height: calc(100%);
        width: calc(100%);
        z-index: 10;
    }

</style>



// WEBPACK FOOTER //
// src/pages/DeceptivePhishingHosting.vue